// @ vendors
const Immutable = require('immutable');
// @ constants
const {
    MORTGAGE_REQUEST_ACCEPT_CONDITIONS_REQUEST,
    MORTGAGE_REQUEST_ACCEPT_CONDITIONS_SUCCESS,
    MORTGAGE_REQUEST_ACCEPT_CONDITIONS_FAILURE
} = require('constants/actionTypes');

const initialState = Immutable.fromJS({
    isFetching: false,
    error: ''
});

const mortgageRequestConditionsAccept = (state = initialState, action) => {
    switch (action.type) {
        case MORTGAGE_REQUEST_ACCEPT_CONDITIONS_REQUEST:
            return state.merge({
                isFetching: true
            });
        case MORTGAGE_REQUEST_ACCEPT_CONDITIONS_SUCCESS:
            return state.merge({
                error: '',
                isFetching: false
            });
        case MORTGAGE_REQUEST_ACCEPT_CONDITIONS_FAILURE:
            return state.merge({
                error: action.data.error,
                isFetching: false
            });
        default:
            return state;
    }
};

module.exports = mortgageRequestConditionsAccept;
